import { __assign } from "tslib";
/* I69 in DS */
import React from 'react';
import IconWrap from '../../IconWrap';
var ReplaceImage = function (props) {
    return (React.createElement(IconWrap, __assign({}, props),
        React.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M14 15l3.25-.083c-1.023 1.81-3.373 2.964-5.472 2.964C8.601 17.881 6.016 15 6.016 12h-1c0 4 3.033 6.881 6.762 6.881 4.055 0 6.222-3.214 6.222-3.214V19h1v-5h-5v1zm-4-6l-3.242.083c1.023-1.81 3.377-2.964 5.476-2.964C15.411 6.119 18 9 18 12h1c0-4-3.041-6.881-6.77-6.881C8.175 5.119 6 8.333 6 8.333V5H5v5h5V9z" }))));
};
ReplaceImage.displayName = 'ReplaceImage';
export default ReplaceImage;
//# sourceMappingURL=ReplaceImage.js.map